import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { Mapper } from '@shared/helpers/mapper';
import {
  EntityEvaluationRequest,
  EvaluationRequest,
  LastQuestionAnswerEvaluationRequest,
  QuestionAnswerEvaluationRequest,
  SecurityEvaluationRequest,
} from '../../../../web-api-client';
import { SecurityForm } from '../../abstractions/security-form';
import { EvaluationQuestion } from '../../models/evaluation-question';

export const mapToEvaluationRequest = (
  taxPolicyId: number,
  taxRuleId: number,
  formValue: Partial<SecurityForm>,
  questions: EvaluationQuestion[]
): EvaluationRequest => {
  const isGeneralRates =
    formValue.transactionType === TransactionType.GeneralRates;

  return Mapper.map(formValue, EvaluationRequest, [
    {
      generalRateEntityTypeId: isGeneralRates
        ? formValue.generalRateEntityTypeId
        : undefined,
      clientId: isGeneralRates ? formValue.clientId : undefined,
      entity: Mapper.map(formValue, EntityEvaluationRequest, [
        {
          entityId(_source): number | undefined {
            return isGeneralRates ? 0 : formValue.entity?.entityId;
          },
        },
      ]),
      processedAnswers: Mapper.mapByList(
        questions.slice(0, -1),
        QuestionAnswerEvaluationRequest,
        ['answer', 'name']
      ),
      lastAnswer:
        questions.length > 0
          ? Mapper.map(
              questions[questions.length - 1],
              LastQuestionAnswerEvaluationRequest,
              [
                'answer',
                'name',
                {
                  unsureAnswer(_source): boolean | undefined {
                    return _source.answer === 'unsure';
                  },
                },
              ]
            )
          : undefined,
      taxPolicyId: (_source: Partial<SecurityForm>): number => taxPolicyId,
      taxRuleId: (_source: Partial<SecurityForm>): number => taxRuleId,
      security: Mapper.map(formValue, SecurityEvaluationRequest, [
        {
          acquisitionDate(_source, _destiny): Date | undefined {
            return formValue.acquisitionDate &&
              formValue.acquisitionDate.length > 0
              ? (formValue.acquisitionDate as Date[])[0]
              : undefined;
          },
          transactionTypeId(_source, _destiny): number | undefined {
            return formValue.transactionType;
          },
        },
      ]),
    },
  ]);
};
